export default "__VITE_ASSET__myE8AvQZ__"